(function () {
  'use strict';

  var MQ = '(max-width: 749px)';
  var SWIPE_MIN_PX = 40;
  var AXIS_RATIO = 1.15;

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function showSecondImage(wrapper) {
    if (!wrapper) return;
    wrapper.style.opacity = '1';
    wrapper.style.transform = 'scale(1)';
  }

  function hideSecondImage(wrapper) {
    if (!wrapper) return;
    wrapper.style.opacity = '0';
    wrapper.style.transform = 'scale(1.2)';
  }

  function clearAllSecondImages() {
    document.querySelectorAll('.product-item__image--two').forEach(function (el) {
      hideSecondImage(el);
    });
  }

  function bindCard(productItem) {
    if (productItem.dataset.lopSwipeBound === '1') return;

    var secondImageWrapper = productItem.querySelector('.product-item__image--two');
    var link = productItem.querySelector('.product-item__media .product-item__image-link');
    if (!secondImageWrapper || !link) return;

    productItem.dataset.lopSwipeBound = '1';

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var suppressClick = false;
    var showing = false;

    link.addEventListener(
      'touchstart',
      function (e) {
        if (!isMobile()) return;
        if (e.touches.length !== 1) return;
        tracking = true;
        suppressClick = false;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    link.addEventListener(
      'touchmove',
      function () {
        if (!isMobile()) tracking = false;
      },
      { passive: true }
    );

    link.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (!isMobile()) return;

        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        var adx = Math.abs(dx);
        var ady = Math.abs(dy);

        if (adx >= SWIPE_MIN_PX && adx > ady * AXIS_RATIO) {
          suppressClick = true;
          window.setTimeout(function () {
            suppressClick = false;
          }, 350);

          var fresh = productItem.querySelector('.product-item__image--two');
          if (dx < 0 && !showing) {
            showSecondImage(fresh);
            showing = true;
          } else if (dx > 0 && showing) {
            hideSecondImage(fresh);
            showing = false;
          }
        }
      },
      { passive: true }
    );

    link.addEventListener(
      'click',
      function (e) {
        if (suppressClick) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function scan() {
    document.querySelectorAll('.product-item').forEach(bindCard);
  }

  var scanTimer;
  function scheduleScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 200);
  }

  function onMqChange(e) {
    if (!e.matches) {
      clearAllSecondImages();
    }
  }

  function init() {
    var mq = window.matchMedia(MQ);
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else {
      mq.addListener(onMqChange);
    }
    scan();
    new MutationObserver(scheduleScan).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
